import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "顧客理解を深めるワークショップを実施しました。このワークショップはJOB理論に基づき、顧客が成し遂げたいことを明確にしました。これをもとに、ソリューションアイデアの創出まで実施しました。"

const ogpImg = "https://aitria.co.jp/images/img/cases/ando/ogp_ando.png"

export const andoPageMeta: PageMeta = {
  title: "JOB理論1dayワークショップ | 事例 | Aitria（アイトリア）",
  description,
  keyword: "DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション",
  image: ogpImg,
  url: `${SITE_URL}/cases/ando/`,
}

export const andoSchema = buildCaseStudySchema({
  slug: "ando",
  pageTitle: andoPageMeta.title,
  description: andoPageMeta.description,
  headline: "JOB理論1dayワークショップ",
  alternativeHeadline: "株式会社安藤・間",
  primaryImage: ogpImg,
  images: [ogpImg,"https://aitria.co.jp/images/img/cases/caseStudyTop/ando.webp"],
  clientName: "株式会社安藤・間",
  breadcrumbLabel: "JOB理論1dayワークショップ",
})
